import { useCallback, useMemo, useEffect, useState } from 'react';
import { useDropdownState } from '../abstract/dropdown';

export function usePriceFilters({
  config,
  query,
  setFilters,
  updateQuery,
  status,
}) {
  let priceBucketPredicate = useCallback((bucket, status) => bucket.statuses.includes(status.value), []);
  let [ prevStatus, setPrevStatus] = useState(status);

  let { selected: priceMin, onSelect: onPriceMinSelect, options: priceMinOptions } = useDropdownState({
    buckets: config.priceRanges,
    bucketValue: status,
    bucketPredicate: priceBucketPredicate,
    defaultValue: query.priceMin || config.priceMinDefault,
    filterKey: `priceFrom`,
    setFilters,
    updateQuery,
  });

  let { selected: priceMax, onSelect: onPriceMaxSelect, options: priceMaxOptions } = useDropdownState({
    buckets: config.priceRanges,
    bucketValue: status,
    bucketPredicate: priceBucketPredicate,
    defaultValue: query.priceMax || config.priceMaxDefault,
    filterKey: `priceTo`,
    setFilters,
    updateQuery,
  });


  priceMinOptions = usePriceMinOptions({ options: priceMinOptions, priceMax });
  priceMaxOptions = usePriceMaxOptions({ options: priceMaxOptions, priceMin });

  useEffect(() => {
    if (prevStatus === status) return;

    setPrevStatus(status);
    onPriceMinSelect(null);
    onPriceMaxSelect(null);
  }, [status]);

  return {
    priceMin,
    priceMinOptions,
    onPriceMinSelect,
    priceMax,
    priceMaxOptions,
    onPriceMaxSelect
  };
}

function usePriceMinOptions({ options, priceMax }) {
  return useMemo(() => {
    if (!priceMax) return options;
    return options.map(x => x.value >= priceMax.value ? ({ ...x, disabled: true }) : x);
  }, [options, priceMax]);
}

export function usePriceMaxOptions({ options, priceMin }) {
  return useMemo(() => {
    if (!priceMin) return options;
    return options.map(x => x.value <= priceMin.value ? ({ ...x, disabled: true }) : x);
  }, [options, priceMin]);
}
